import { RouterProvider } from 'react-router-dom';
import accountRouter from './accountingservices/accountRouter';
import './App.css';
import MainRouter from './MainRouter';
import inventoryRouter from './inventoryServices/inventoryRouter';
import contactRouter from './contactServices/contactRouter';
import purchaseRouter from './purchaseServices/purchaseRouter';
import salesRouter from './saleservices/salesRouter';
import mainRouter from './mainService/mainRouter';
import employeeRouter from './employeeServices/employeeRouter';
import expenseRouter from './expenseservices/expenseRouter';
import { useEffect, useState, useTransition } from 'react';
import SignIn from './SignIn';
import AuthContext from './utils/AuthContext';
import useAuthApi from './utils/useAuthApi';


// Email notifications


function App() {
  const { user, isLoggedIn, getUserSession, signIn, signOut } = useAuthApi();

  const router = MainRouter(
    accountRouter, 
    inventoryRouter, 
    contactRouter, 
    purchaseRouter,
    salesRouter,
    mainRouter,
    employeeRouter,
    expenseRouter,
    user.access_right
  );

  useEffect(() => {
    getUserSession()
  },[])

  

  // console.log('Transition loading: ', pending);
  return (
    <div className="App bg-slate-100">
      { user.user ? 
        <AuthContext.Provider value={{user, signOut}}>
          <RouterProvider router={router}/>
        </AuthContext.Provider>
      : <SignIn />
      }
    </div>
  );
}

export default App;
